/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PaginatedResponse } from '../../models/paginated-response';

export interface AlbumsControllerFindAllByEventSlug$Params {
  slug: string;
  page?: number;
  limit?: number;

/**
 * Search in album name (SK or EN)
 */
  search?: string;

/**
 * Filter by active status
 */
  isActive?: boolean;

/**
 * Filter albums connected to event ID
 */
  connectedEventId?: string;

/**
 * Filter albums connected to event slug
 */
  connectedEventSlug?: string;

/**
 * Filter by tag IDs (album tags or event tags)
 */
  tagIds?: Array<string>;

/**
 * Sort by field (createdAt, updatedAt, name, photoCount, isActive, eventDate)
 */
  sortBy?: string;

/**
 * Sort order
 */
  sortOrder?: 'ASC' | 'DESC';
}

export function albumsControllerFindAllByEventSlug(http: HttpClient, rootUrl: string, params: AlbumsControllerFindAllByEventSlug$Params, context?: HttpContext): Observable<StrictHttpResponse<PaginatedResponse>> {
  const rb = new RequestBuilder(rootUrl, albumsControllerFindAllByEventSlug.PATH, 'get');
  if (params) {
    rb.path('slug', params.slug, {});
    rb.query('page', params.page, {});
    rb.query('limit', params.limit, {});
    rb.query('search', params.search, {});
    rb.query('isActive', params.isActive, {});
    rb.query('connectedEventId', params.connectedEventId, {});
    rb.query('connectedEventSlug', params.connectedEventSlug, {});
    rb.query('tagIds', params.tagIds, {});
    rb.query('sortBy', params.sortBy, {});
    rb.query('sortOrder', params.sortOrder, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PaginatedResponse>;
    })
  );
}

albumsControllerFindAllByEventSlug.PATH = '/albums/by-event/{slug}';
